ike-event-stream{
  $sidewidth: 440px;
  background: black;
  color: white;
  display: flex;
  //height: 100%;
  overflow: auto;
  min-height: 100%;
  flex-direction: row-reverse;

  .LG &{
    display: block;
    position: relative;
    height: auto;
    padding: 15px;
    min-height: 100%;
    background-color: black;
    background-image: var(--posterbg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  p{
    padding-bottom: 7px;
  }

  a{
    color: cornflowerblue !important;
    &:hover{
      text-decoration: underline;
    }
  }

  .stream-sidebar{
    width: $sidewidth;
    position: relative;
    padding: 44px;
    background-color: black;
    background-image: var(--posterbg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .LG &{
      background: none;
      margin: auto;
      width: 320px;
      padding: 0;
    }
    .stream-title, .stream-countdown{
      display: flex;
      .LG &{
        display: none;
      }
    }
  }

  .stream-title{
    margin-bottom: 43px;
    text-align: left;
    &--logo{
      //width: 186px;
    }
    &--title {
      font-size: 25px;
      font-weight: 900;
      line-height: 33px;
    }
    &--date{
      text-transform: capitalize;
      opacity: 0.7;
      font-size: 19.2px;
      line-height: 25px;
    }
  }

  .stream-main{
    font-size: 16px;
    text-align: center;
    width: calc(100% - #{$sidewidth});
    position: relative;
    .LG &{
      margin: auto;
      width: 320px;
      position: static;
    }

    .stream-main_line{
      line-height: 20px;
      padding-bottom: 34px;
    }

    .stream-main_form{
      width: 592px;
      margin: 220px auto 0;
      .LG &{
        margin: 0;
        width: 320px;
      }
    }

    .stream-main_input{
      background: white;
      height: 50px;
      line-height: 50px;
      //font-size: 30px;
      width: 100%;
      border: 0;
      border-radius: 3px;
      padding: 0 20px;
      text-transform: uppercase;
    }

    .stream-main_button{
      height: 50px;
      width: 230px;
      border-radius: 25px;
      background: #9C0D0D;
      color: white;
      &[disabled]{
        opacity: .5;
      }
    }

    .btn-label{
      color: #9C0D0D;
    }

    .stream-title, .stream-countdown{
      display: none;
      .LG &{
        display: flex;
      }
    }
  }

  .stream-countdown{
    margin-bottom: 40px;
    display: flex;
    $posterwidth: 67.39px;
    .stream-countdown_direct{
      background: rgba(255,255,255,0.16);
      text-transform: uppercase;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 10px;
      display: inline-block;
      border-radius: 4px;
      &__bullet{
        color: red;
      }
    }
    .stream-countdown_date{
      color: rgba(255,255,255,0.7);
      font-size: 14px;
      line-height: 18px;
    }
    .stream-countdown_poster{
      width: $posterwidth;
    }
    .stream-countdown_content{
      padding: 0 15px;
      width: calc(100% - #{$posterwidth});
    }
    .stream-countdown_numbers{
      display: flex;
      width: 100%;
      justify-content: space-between;

      font-size: 30.4px;
      font-weight: 900;
      line-height: 39px;

      &__titles{
        opacity: .6;
        font-size: 11.2px;
        line-height: 14px;
      }

      &__number{
        flex-grow: 0;
        flex-basis: 25%;
        text-align: center;

        &:nth-child(even){
          flex-grow: 0;
          flex-basis: 0;
          text-align: center;
        }
      }
    }
  }

  .stream-help{
    padding: 13px;
    border-radius: 8px;
    background: rgba(0,0,0,0.25);
    display: flex;
    font-size: 13px;
    line-height: 20px;
    >:first-child{
      width: 24px;
    }
    >:last-child{
      margin-left: 10px;
      width: calc(100% - 34px);
    }
    a{
      color: bisque;
    }
  }

  .stream-video{
    margin: 100px 0 0;
    .LG &{
      margin: 0;
    }
    .stream-video_title{
      font-size: 28px;
      font-weight: 500;
      line-height: 37px;
    }
    .stream-video_subtitle{
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
    }
    .stream-video_refreshmsg{
      opacity: 0.7;
      font-size: 14px;
      line-height: 18px;
      .LG &{
        display: none;
      }
    }
    .stream-video_frame{
      width:1280px;
      max-width:100%;
      height:720px;
      margin-top: -20px;
      .LG &{
        height:180px;
      }
    }
  }

  .stream-icon {
    width: 58px;
    filter: brightness(0) invert(1);
    .LG &{
      width: 54px;
    }
  }

  .stream-kmeet{
    display: flex;
    max-width: 966px;
    margin: 0 auto;
    background: rgba(255,255,255, 0.16);
    border-radius: 8px;
    padding: 15px;
    align-items: center;
    margin-bottom: 50px;
    .LG &{
      display: block;
    }

    p{
      padding: 0;
    }

    .stream-kmeet_picture{
      margin-left: 15px;
      .LG &{
        margin-bottom: 15px;
      }
      .stream-kmeet_picture-icon{
        filter: brightness(0) invert(1);
        width: 40px;
      }
      .stream-kmeet_picture-text{
        white-space: nowrap;
        font-size: 8px;
        font-weight: 500;
        line-height: 10px;
        text-transform: uppercase;
      }
      .stream-kmeet_picture-bullet{
        color: red;
      }
    }

    .stream-kmeet_text{
      margin-left: 15px;
      font-size: 13px;
      line-height: 20px;
      text-align: left;
      .LG &{
        margin-bottom: 15px;
      }
    }

    .stream-kmeet_action{
      color: rgba(255,255,255, .6);
      font-size: 11px;
      line-height: 20px;
      .stream-kmeet_action-button{
        width: 230px;
        border-radius: 25px;
        background-color: white;
        line-height: 41px;
        color: #FF0000;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 4px;
      }
    }
  }
}
